module.exports = {"intakeConfig":{"housing":null,"referral":null,"sex":null,"family":null,"ssi":null,"senior":null}}


//////////////////
// WEBPACK FOOTER
// ./src/store/init.json
// module id = 241
// module chunks = 1